import { Box, Typography } from '@mui/material'
import { PropsWithChildren } from 'react'

export default function ErrorScreen({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <Typography variant='h6' color='error'>
        {children || 'Something went wrong...'}
      </Typography>
    </Box>
  )
}
